<template>
    <div>
        <contract-form-sidebar
            :is-sidebar-active.sync="isSidebarActive"
            :data="data"
            ref="data"
        />
        <b-button
            variant="gradient-primary"
            class="btn-icon"
            v-b-tooltip.hover.v-dark
            title="Generar Pago"
            v-b-modal.modal-paypal
        >
            <feather-icon icon="FileTextIcon" />
        </b-button>
        <b-button
            variant="gradient-info"
            class="btn-icon"
            v-b-tooltip.hover.v-dark
            title="Estado de Cuenta"
            v-b-modal.modal-contract-account
        >
            <feather-icon icon="CreditCardIcon" />
        </b-button>
        <b-button
            variant="gradient-success"
            class="btn-icon"
            v-b-tooltip.hover.v-dark
            title="Orden Trabajo"
            @click="ot()"
        >
            <feather-icon icon="ToolIcon" />
        </b-button>
        <b-button
            variant="gradient-warning"
            class="btn-icon"
            v-b-tooltip.hover.v-dark
            title="Editar"
            @click="
                isSidebarActive = true;
                handleClick(data, data.idcontrato);
            "
        >
            <feather-icon icon="EditIcon" />
        </b-button>

        <b-modal
            id="modal-paypal"
            ref="modal-paypal"
            content-class="shadow"
            ok-only
            centered
            ok-variant="outline-secondary"
            ok-title="Cerrar"
            no-close-on-backdrop
            size="lg"
            :title="`Ingresar Pago ${data.codigo} - ${data.apenom}`"
        >
            <pay-pal :idcontrato="data.idcontrato" />
        </b-modal>

        <b-modal
            id="modal-contract-account"
            ref="modal-contract-account"
            ok-only
            centered
            ok-variant="outline-secondary"
            ok-title="Cerrar"
            size="xl"
            ignore-enforce-focus-selector=".swal2-container, .swal2-center"
            :title="`Estado Cuenta ${data.codigo} - ${data.apenom}`"
        >
            <contract-account-status :data="data" />
        </b-modal>
    </div>
</template>

<script>
import PayPal from "@/views/home/PayPal.vue";
import { ref } from "@vue/composition-api";
import { BButton, BForm, BFormGroup, VBTooltip } from "bootstrap-vue";
import ContractAccountStatus from "./ContractAccountStatus.vue";
import ContractFormSidebar from "./ContractFormSidebar.vue";
import ModalOt from "./modal/ModalOt.vue";

export default {
    components: {
        BButton,
        BForm,
        BFormGroup,
        ContractFormSidebar,
        ContractAccountStatus,
        ModalOt,
        PayPal,
    },
    setup() {
        const isSidebarActive = ref(false);
        return {
            isSidebarActive,
        };
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem("userData")),
            show: true,
            dataContrato: [],
        };
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    created() {},
    methods: {
        ot() {
            this.$root.$emit("bv::show::modal", "modal-ot");
        },
        handleClick(item, index) {
            this.$refs.data.parametros(item, item.idcontrato);
        },
        reload() {
            this.$root.$emit("bv::hide::modal", "modal-discount");
            this.$emit("reload");
        },
    },
};
</script>

<style></style>
